module.exports = __webpack_public_path__ + "static/media/report-cards-active.2eb57bfe.svg";